import { useCallback, useState } from 'react'

export type ViewMode = 'card' | 'list'

const storageKey = (pageKey: string) => `viewMode:${pageKey}`

const readStoredMode = (pageKey: string): ViewMode | null => {
  try {
    const stored = localStorage.getItem(storageKey(pageKey))
    return stored === 'card' || stored === 'list' ? stored : null
  } catch {
    return null
  }
}

/**
 * Card/list view choice for a list page, remembered per page in localStorage.
 */
export function useViewMode(pageKey: string, defaultMode: ViewMode = 'list') {
  const [viewMode, setViewModeState] = useState<ViewMode>(
    () => readStoredMode(pageKey) ?? defaultMode,
  )

  const setViewMode = useCallback(
    (mode: ViewMode) => {
      setViewModeState(mode)
      try {
        localStorage.setItem(storageKey(pageKey), mode)
      } catch {
        // storage unavailable (private mode); keep the in-memory choice
      }
    },
    [pageKey],
  )

  return [viewMode, setViewMode] as const
}
